import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-onlinepayment',
  templateUrl: './onlinepayment.component.html'
})
export class OnlinePaymentComponent {

  @Input() orderId!: number;        // ✅ الأوردر اتعمل خلاص
  @Output() success = new EventEmitter<any>();
  @Output() failed = new EventEmitter<any>();

  sessionUrl: string | null = null;
  loading = false;

  constructor(private http: HttpClient) { }

  startPayment() {
    if (!this.orderId) {
      this.failed.emit('Missing orderId');
      return;
    }

    this.loading = true;

    // ✅ endpoint خاص بإنشاء Kashier session
    this.http.post<any>(`API/orders/${this.orderId}/pay`, {})
      .subscribe({
        next: (res) => {
          if (res.sessionUrl) {
            this.sessionUrl = res.sessionUrl;
          } else {
            this.failed.emit('No session url');
          }
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.failed.emit(err);
        }
      });
  }

  // 👇 optional (لو عملت polling)
  paymentDone() {
    this.success.emit(true);
  }
}
